import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { OidcSignupEffects } from './oidc-signup.effects';
import { OidcSignupFacade } from './oidc-signup.facade';
import { OIDC_SIGNUP_FEATURE_KEY, oidcSignupReducer } from './oidc-signup.reducer';

@NgModule({
    imports: [
        StoreModule.forFeature(OIDC_SIGNUP_FEATURE_KEY, oidcSignupReducer),
        EffectsModule.forFeature([OidcSignupEffects])
    ],
    providers: [OidcSignupFacade, OidcSignupEffects]
})
export class OidcSignupModule {}
